class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.closeTimer = null;
    this.hoverMedia = window.matchMedia('(min-width: 990px) and (hover: hover)');

    this.onHeaderMenuEnter = this.onHeaderMenuEnter.bind(this);
    this.onHeaderMenuLeave = this.onHeaderMenuLeave.bind(this);
    this.onHoverMediaChange = this.onHoverMediaChange.bind(this);
    this.onSummaryClickWhileHoverNav = this.onSummaryClickWhileHoverNav.bind(this);

    this.hoverMedia.addEventListener('change', this.onHoverMediaChange);
    this.bindHeaderMenuHoverOpen();
  }

  disconnectedCallback() {
    this.hoverMedia.removeEventListener('change', this.onHoverMediaChange);
    this.unbindHeaderMenuHoverOpen();
  }

  onHoverMediaChange() {
    this.bindHeaderMenuHoverOpen();
  }

  bindHeaderMenuHoverOpen() {
    this.unbindHeaderMenuHoverOpen();
    if (!this.hoverMedia.matches) return;

    this.addEventListener('mouseenter', this.onHeaderMenuEnter);
    this.addEventListener('mouseleave', this.onHeaderMenuLeave);
    this.summary.addEventListener('click', this.onSummaryClickWhileHoverNav);
  }

  unbindHeaderMenuHoverOpen() {
    this.removeEventListener('mouseenter', this.onHeaderMenuEnter);
    this.removeEventListener('mouseleave', this.onHeaderMenuLeave);
    this.summary.removeEventListener('click', this.onSummaryClickWhileHoverNav);
    if (this.closeTimer) {
      clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }
  }

  /**
   * Mouse clicks on <summary> would toggle the menu closed while still hovered.
   * Keyboard (detail === 0) keeps native toggle for accessibility.
   */
  onSummaryClickWhileHoverNav(event) {
    if (!this.hoverMedia.matches) return;
    if (event.detail === 0) return;
    event.preventDefault();
  }

  onHeaderMenuEnter() {
    if (!this.hoverMedia.matches) return;
    if (this.closeTimer) {
      clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }

    const nav = this.closest('.header__inline-menu');
    if (nav) {
      nav.querySelectorAll('header-menu').forEach((menu) => {
        if (menu !== this && typeof menu.close === 'function') menu.close();
      });
    }

    this.mainDetailsToggle.setAttribute('open', '');
  }

  onHeaderMenuLeave() {
    if (!this.hoverMedia.matches) return;
    if (this.closeTimer) clearTimeout(this.closeTimer);
    this.closeTimer = setTimeout(() => {
      this.closeTimer = null;
      this.close();
    }, 200);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
